<template>
  <v-dialog
    v-model="dialogModel"
    :width="$vuetify.breakpoint.mdAndUp ? '600px' : ''"
  >
    <v-card>
      <v-card-title class="primary accent--text">
        {{ isEditMode ? $t('common.edit') : $t('common.create') }} Booking

        <v-spacer/>

        <cancel-booking-dialog
          v-if="isEditMode && _get(getBookingDialogData, 'booking.id')"
          :id="getBookingDialogData.booking.id"
          @action="onCancelAction"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="accent"
              outlined
              small
              rounded
              v-on="on"
            >
              <v-icon small left>cancel</v-icon>

              Cancel
            </v-btn>
          </template>
        </cancel-booking-dialog>

      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="12">
            <v-row>

              <v-col cols="12" class="py-0" v-if="isEditMode || (selectedCustomer && !isSearchingCustomer)">
                <v-row>
                  <v-col
                    cols="5"
                    class="py-1 grey--text"
                  >
                    Customer Name
                  </v-col>
                  <v-col
                    cols="7"
                    class="py-1"
                  >
                    <div>
                      {{ customer().name }}

                      <v-btn
                        v-if="isEditMode"
                        small
                        icon
                      >
                        <v-icon
                          small
                          @click="onGotoCustomer()"
                        >
                          open_in_new
                        </v-icon>
                      </v-btn>

                      <v-btn
                        v-if="!isEditMode"
                        class="ml-2"
                        small
                        rounded
                        outlined
                        @click="clearSelectedCustomer()"
                      >
                        <v-icon small left>clear</v-icon>

                        clear
                      </v-btn>

                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" class="py-0" v-if="!isEditMode && (!selectedCustomer || isSearchingCustomer)">
                <v-row
                  align="center"
                  justify="center"
                  class="mb-3"
                >
                  <customer-search-dialog
                    @action="onSelectCustomerAction"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        rounded
                        outlined
                        color="primary"
                        v-on="on"
                      >
                        <v-icon small left>search</v-icon>
                        Find Customer
                      </v-btn>
                    </template>

                  </customer-search-dialog>

                  <span class="mx-3">or</span>
                  <customer-create-dialog
                    @action="onCreateCustomerAction"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        rounded
                        outlined
                        color="primary"
                        v-on="on"
                      >
                        <v-icon small left>add</v-icon>
                        New Customer
                      </v-btn>
                    </template>
                  </customer-create-dialog>

                </v-row>
              </v-col>


              <template v-for="(item, itemIndex) in infoList()">
                <v-col
                  cols="5"
                  class="py-1 grey--text"
                >
                  {{ item.label }}
                </v-col>
                <v-col
                  cols="7"
                  class="py-1"
                >
                  <template>
                    <div>{{ item.value }}</div>
                  </template>
                </v-col>

              </template>

              <template v-if="!isEditMode">
                <v-col
                  cols="5"
                  class="py-1 grey--text"
                >
                  Note
                </v-col>
                <v-col
                  cols="7"
                  class="py-1"
                >
                  <template>
                    <v-textarea
                      v-model="note"
                      outlined
                      dense
                      auto-grow
                      rows="2"
                      hide-details
                    />
                  </template>
                </v-col>
              </template>
            </v-row>

            <template v-if="isLoadingCustomerInfo">
              <v-progress-circular
                :size="50"
                :width="3"
                color="primary"
                indeterminate
              />
            </template>
            <template v-if="!isLoadingCustomerInfo">
              <v-row v-if="selectedCustomer && !isProductFree() && !isSearchingCustomer">
                <v-divider class="my-3" />
                <v-col cols="12">
                  Payment Option
                  <v-radio-group v-model="payInvoice" :mandatory="true" hide-details>
                    <v-radio
                      v-if="defaultSource"
                      :label="`Charge default payment method (${cardDisplay()})`"
                      :value="true"
                    />
                    <v-radio
                      label="Send invoice to pay manually"
                      :value="false"
                    />
                  </v-radio-group>
                  <v-row v-if="payInvoice === false">
                    <v-col cols="4">
                      <v-text-field
                        v-model.number="daysUntilDue"
                        dense
                        outlined
                        label="Days until due"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="isLoading"
          rounded
          outlined
          @click="dialogModel = false"
        >
          close
        </v-btn>
        <v-btn
          v-if="!isEditMode"
          :loading="isLoading"
          :disabled="isLoading || !canCreateBooking()"
          rounded
          outlined
          color="primary"
          @click="onCreateBooking()"
        >
          create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import DivisionsDropDown from "../Common/DivisionsDropDown"
import { isEmpty, get, isString, isNumber } from "lodash"
import { convertTimestampToDate } from "../../services/util.service"
import InfoList from "../Common/InfoList"
import CancelBookingDialog from "./CancelBookingDialog"
import CustomerSearchDialog from "../Customer/CustomerSearchDialog"
import CustomerCreateDialog from "../Customer/CustomerCreateDialog"

export default {
  components: { CustomerCreateDialog, CustomerSearchDialog, CancelBookingDialog, InfoList, DivisionsDropDown },
  computed: {
    ...mapGetters([
      'getBookingDialog',
      'getBookingDialogData',
      'getScheduledProducts',
      'getProduct'
    ]),
    dialogModel: {
      get() {
        return this.getBookingDialog
      },
      set(val) {
        this.setBookingDialog(val)
      }
    }
  },
  watch: {
    dialogModel(val) {
      if (val === true) {
        this.onOpen()
      } else {
        this.onClose()
      }
    }
  },
  data() {
    return {
      isLoading: false,
      isEditMode: false,
      customerSearch: '',
      selectedCustomer: null,
      isSearchingCustomer: false,
      isLoadingCustomerInfo: false,
      defaultSource: null,
      payInvoice: false,
      daysUntilDue: 30,
      note: ''
    }
  },
  methods: {
    ...mapActions([ 'getCustomer', 'setBookingDialog', 'listCustomers', 'snackError', 'getCustomerSource', 'createBooking', 'snackSuccess', 'snackError' ]),
    _get: (obj, path, defaultVal) => get(obj, path, defaultVal),
    onCreateCustomerAction(customer){
      this.selectedCustomer = customer
    },
    onSelectCustomerAction(customer){
      this.isLoadingCustomerInfo = true
      this.selectedCustomer = customer
      const { id } = customer;
      const customerPayload = {
        _reload: true,
        id,
        expand: [ 'default_source', 'invoice_settings.default_payment_method']
      }

      this.getCustomer(customerPayload)
        .then((res) => {
          this.defaultSource = get(res, 'invoice_settings.default_payment_method')
            || get(customer, 'default_source') // legacy support
        })
        .finally(() => {
          this.isLoadingCustomerInfo = false
        })
    },
    canCreateBooking() {
      return (!isEmpty(this.selectedCustomer) && isNumber(this.daysUntilDue))
        || (this.isProductFree() && !isEmpty(this.selectedCustomer))

    },
    onCreateBooking() {
      const { booking } = this.getBookingDialogData || {}

      const payload = {
        booking: {
          ...booking,
          customer: this.selectedCustomer.id,
          note: this.note
        },
        payInvoice: this.payInvoice,
        daysUntilDue: this.daysUntilDue
      }

      this.isLoading = true
      this.createBooking(payload)
        .then(res => {
          console.log(res)
          this.$emit('cancel-booking')
          this.dialogModel = false
          const snackSuccessPayload = {
            text: 'Booking created'
          }
          this.snackSuccess(snackSuccessPayload)
        })
        .catch(e => {
          this.snackError(e)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    cardDisplay() {
      const last4 = get(this.defaultSource, 'card.last4', '')
      const brand = get(this.defaultSource, 'card.brand', '')

      return `${brand} ****${last4}`
    },
    clearSelectedCustomer() {
      this.selectedCustomer = null
    },
    isProductFree() {
      const { booking } = this.getBookingDialogData || {}
      const productId = get(booking, 'product')

      return get(this.getProduct(productId), 'amount', 0) === 0
    },
    onCancelAction() {
      this.$emit('cancel-booking')
      const payload = {
        text: 'Booking cancelled'
      }
      this.snackSuccess(payload)
      this.dialogModel = false
    },
    onGotoCustomer() {
      this.dialogModel = false
      this.$router.push({ name: 'customer-detail', params: { id: this.customer().id } })
    },
    onOpen() {
      const customer = this.customer()

      // Is edit mode if customer exists
      this.isEditMode = !isEmpty(customer)
    },
    onClose() {
      this.selectedCustomer = null
      this.defaultSource = null
      this.payInvoice = false
    },
    customer() {
      const { booking } = this.getBookingDialogData || {}
      const customer = get(booking, 'customer') || this.selectedCustomer

      return customer || {}
    },
    infoList() {
      const { booking } = this.getBookingDialogData || {}
      const customer = get(booking, 'customer') || this.selectedCustomer
      const productId = get(booking, 'product')
      const { startAt, endAt } = booking || {}

      const startDate = isString(startAt)
        ? moment(startAt)
        : convertTimestampToDate(startAt)

      const endDate = isString(endAt)
        ? moment(endAt)
        : convertTimestampToDate(endAt)

      let info = [
        {
          label: 'Booking Start',
          value: startDate ? moment(startDate).format('LLLL') : ''
        },
        {
          label: 'Booking End',
          value: endDate ? moment(endDate).format('LLLL') : ''
        },
        {
          label: 'Scheduled Product',
          value: get(this.getProduct(productId), 'label', '')
        }
      ]
      //
      // if (this.isEditMode || this.selectedCustomer) {
      //   info = [
      //     {
      //       label: 'Customer Email',
      //       value: get(customer, 'email', '')
      //     },
      //     ...info
      //   ]
      // }

      if (this.isEditMode) {
        info = [
          ...info,
          {
            label: 'Note',
            value: get(booking, 'note', '')
          }
        ]
      }

      return info
    }
  }
}
</script>
